export function checkWebpImgSupport(){
    var elem = document.createElement('canvas');
    
    if (!!(elem.getContext && elem.getContext('2d')))
    {
        document.documentElement.classList.add('webp');
    }
    else
    {
        document.documentElement.classList.add('no-webp');
    }
}